<template>
  <SortSearch
    default-sort="latest"
    dimension="LatestDesigns"
    :force-experience="getMerch"
    query="dog"
  />
</template>

<script>
import SortSearch from '@/components/SortSearch';
import { mapGetters } from 'vuex';

export default {
  components: {
    SortSearch
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapGetters('experience', ['getMerch'])
  },
  nuxtI18n: {
    paths: {
      en: '/merch/latest-designs',
      es: '/merch/ultimos-disenos',
      pt: '/merch/novos-designs',
      de: '/merch/neue-designs'
    }
  }
};
</script>
